module.exports = __webpack_public_path__ + "static/media/activeProfileTaxStatus.37f54cea.svg";